import ApiEndPoints from '@/services/common/api/apiEndPoints';

import ApiEndPointsBuilder from '@/services/common/api/apiEndPointsBuilder';

class Configuration {
  constructor() {
    this.api = ApiEndPoints;
    this.apiEndPointsBuilder = ApiEndPointsBuilder;
  }

  get ApiEndpoints() {
    return this.api;
  }

  get ApiEndpointsBuilder() {
    return this.apiEndPointsBuilder;
  }
}

export default new Configuration();
